module.exports = __webpack_public_path__ + "assets/img/m-b-1.756ce4fe.png";